import { keepOneOrLine, keepOnePercentOrLine, keepTwoOrLine } from '@/utils/utils';

export const getLoadRange = (value?: number) => {
  if (value == null) return '';
  if (value < 60) return 'low';
  if (value < 80) return 'mid';
  if (value <= 100) return 'high';
  return 'over';
};

export const formatLoadRate = (value?: number) => `${keepOneOrLine(value)}%`;

export const formatDuration = (minutes?: number, percent?: number) => {
  if (minutes == null) return '-';
  const duration = minutes > 60 ? `${keepTwoOrLine(minutes / 60)}小时` : `${keepTwoOrLine(minutes)}分钟`;
  const rate = `${keepOnePercentOrLine(percent)}%`;
  return `${duration}(${rate})`;
};

export const getUniqueOptions = (list: any[], key: string) => {
  return Array.from(new Set(list.map(item => item[key]).filter(Boolean))).map(item => ({
    label: item as string,
    value: item as string,
  }));
};

export const filterList = (list: any[], filters: any) => {
  const { activeRange, name, startPoint, endPoint, gasSource, rateValue, rateOperator } = filters;

  return list.filter(item => {
    if (activeRange && getLoadRange(item.realtimeLoadRate) !== activeRange) return false;
    if (name && !item.name?.includes(name) && !item.code?.includes(name)) return false;
    if (startPoint && !item.startPoint?.includes(startPoint)) return false;
    if (endPoint && !item.endPoint?.includes(endPoint)) return false;
    if (gasSource && !item.gasSource?.includes(gasSource)) return false;

    if (rateValue != null) {
      const value = Number(item.realtimeLoadRate);
      if (rateOperator === '>' && !(value > rateValue)) return false;
      if (rateOperator === '>=' && !(value >= rateValue)) return false;
      if (rateOperator === '<' && !(value < rateValue)) return false;
      if (rateOperator === '<=' && !(value <= rateValue)) return false;
      if (rateOperator === '=' && !(value === rateValue)) return false;
    }

    return true;
  });
};
